const cloudbedsAuthMessages = {
  subtitle: 'Authenticate to Cloudbeds',
  title: 'Welcome to Virdee',
};

export default cloudbedsAuthMessages;
